import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState(null);
  const [settings, setSettings] = useState(null);

  const loadMeta = useCallback(async () => {
    const [m, s] = await Promise.all([api.get("/meta"), api.get("/settings")]);
    setMeta(m.data);
    setSettings(s.data);
  }, []);

  useEffect(() => {
    api.get("/auth/me").then((r) => { setUser(r.data); loadMeta(); }).catch(() => setUser(false));
    const onLogout = () => setUser(false);
    window.addEventListener("vmw:logout", onLogout);
    return () => window.removeEventListener("vmw:logout", onLogout);
  }, [loadMeta]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
    await loadMeta();
    return r.data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, meta, settings, reloadSettings: loadMeta }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
